import React from 'react'
import { Box, useStyleConfig } from '@chakra-ui/react'
function Content(props) {
  const { variant, children, ...rest } = props
  const styles = useStyleConfig('Content', { variant })
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  )
}

export default Content
